import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import {AuthService} from 'src/app/services/auth/auth.service';
import {RouterSegments} from 'src/app/models/router-segments';
import {Permission} from '../../models/principal/permission';
import { TenantService } from 'src/app/services/api/tenant.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { Router } from '@angular/router';
import { InstancesService } from 'src/app/services/api/instances.service';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';
import { ActivatedRoute } from '@angular/router';
import { translate } from '@jsverse/transloco';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { Constants } from 'src/app/models/constants';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { MatTableDataSource } from '@angular/material/table';
import { SolutionVersionsService } from 'src/app/services/util/solution-versions.service';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { Permissions } from 'src/app/models/principal/permission';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import cronstrue from 'cronstrue';
import { CobService } from 'src/app/services/api/cob.service';
import { takeUntil, catchError, throwError, finalize, Subject, filter, take } from 'rxjs';
import { JumpboxService } from 'src/app/services/api/jumpbox.service';
import { Jumpbox, JumpboxTypes } from 'src/app/models/tenant/jumpbox';
import { getDiffDays } from 'src/app/services/util/utils';
import cloneDeep from 'lodash/cloneDeep';
import { CalendarEvent } from 'angular-calendar';
import moment from 'moment';
import { CronExpressionParser } from 'cron-parser';
import { SchedulerService } from 'src/app/services/api/scheduler.service';
import { MatDialog } from '@angular/material/dialog';
import { ScheduleDetailsComponent } from './schedule-details/schedule-details.component';
import { CloudProvider } from 'src/app/models/cloud-provider/cloud-provider';
import { TenantOrigin } from 'src/app/models/tenant/tenant-status';
import { DisasterRecoveryService } from 'src/app/services/api/disaster-recovery.service';
import { FeatureFlagsManagerService } from 'src/app/services/util/feature-flags-manager.service';
import { FeatureFlags } from 'src/app/models/constants/feature-flags.constant';
import { FeatureFlagsResponse } from 'src/app/models/feature-flag.model';
import {FeatureService} from 'src/app/services/api/feature.service';
import { ChangeDetectorRef } from '@angular/core';


const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.BLUEPRINT_READ,
    action: Permissions.BLUEPRINT_READ
  }
];

@Component({
    selector: 'app-tenant-dashboard',
    templateUrl: './tenant-dashboard.component.html',
    styleUrls: ['./tenant-dashboard.component.scss'],
    standalone: false
})
export class TenantDashboardComponent  implements OnInit {
private destroyRef = inject(DestroyRef);

  PermissionKeys = PermissionKeys;
  DeployStatus = DeployStatus;
  tenant: string;
  enterpriseClient: boolean;
  deployedStatus: any[] = [];
  RouterSegments = RouterSegments;
  instanceCountdata: any;
  tenantsList: any[] = [];
  selectedTenant: any;
  instanceDetails: any[] = [];
  instanceByDatazone: any[] = [];
  instanceByStatus: any[] = [];
  datazoneColumns: string[] = ['name', 'value'];
  instanceBySerDefColumns = ['name', 'version', 'status'];
  instanceByCobColumns = ['name', 'schedule', 'status'];
  recentActivityColumns = ['instance', 'activity'];
  instanceBySolutionPiechart: any;
  instanceByMonthChart: any;
  monthArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  yearDropdown = [];
  selectedYear: string;
  chartData: any;
  overallInstances: number;
  insightTiles = [
    {
      key: 'total',
      icon: 'task_alt',
      title: 'TENANT_DASHBOARD.TOTAL',
      count: 0,
      loading: true
    },
    {
      key: 'deployed',
      icon: 'task_alt',
      title: 'TENANT_DASHBOARD.DEPLOYED_INSTANCES',
      count: 0,
      loading: true
    },
    {
      key: 'deploying',
      icon: 'sync',
      title: 'TENANT_DASHBOARD.DEPLOYING_INSTANCES',
      count: 0,
      loading: true
    }
  ];

  isInstanceLoaded = false;
  tenantId: any;
  blueprints: any;
  selectedBlueprint: any;
  instances: any = [];
  instanceByServiceDefinition: any = [];
  instanceByClass: any;
  selectedBlueprintForClass: any;
  instancesForClass: any = [];
  isInsSelectionLoaded = false;
  isInsClassLoaded = false;
  instanceSize: number;
  permissionsMap: { [key: string]: boolean };
  instancePermission = true;
  showJumpBox: boolean;
  showSchedule : boolean;
  isExternalTenant = false;
  private featureFlagsManagerService = inject(FeatureFlagsManagerService);

  readonly inprogressStatuses = [DeployStatus.DEPLOYING, DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.TESTING,
    DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING, DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.OPERATION_INPROGRESS, DeployStatus.INPROGRESS,
    DeployStatus.INITIALIZING, DeployStatus.STARTING_AGENT, DeployStatus.STARTING,
    DeployStatus.TERMINATING, DeployStatus.STOPPING_AGENT, DeployStatus.STOPPING, DeployStatus.DELETING];

  inprogressStatus = [DeployStatus.DEPLOYING, DeployStatus.INITIALIZING, DeployStatus.UPDATING, DeployStatus.CONFIGURING, DeployStatus.OPERATION_INPROGRESS, DeployStatus.INPROGRESS, DeployStatus.STARTING_AGENT, DeployStatus.STOPPING_AGENT, DeployStatus.STARTING, DeployStatus.STOPPING, DeployStatus.TERMINATING, DeployStatus.TESTING, DeployStatus.FALLBACK_INPROGRESS,  DeployStatus.FAILOVER_INPROGRESS];
  errorStatus = [DeployStatus.FAILED, DeployStatus.INITIALIZE_FAILED, DeployStatus.UPDATE_FAILED, DeployStatus.CONFIGURATION_FAILED, DeployStatus.START_FAILED, DeployStatus.STOP_FAILED, DeployStatus.TERMINATION_FAILED];
  terminateStatus = [DeployStatus.TERMINATED, DeployStatus.STOPPED];
  completedStatus = [DeployStatus.DEPLOYED, DeployStatus.INITIALIZED, DeployStatus.UPDATED, DeployStatus.CONFIGURED, DeployStatus.TESTED];

  colorsByStatus = [
    {status: DeployStatus.DEPLOYING, color: '#EF7839'},
    {status: DeployStatus.TERMINATING, color: '#EF7839'},
    {status: DeployStatus.CONFIGURING, color: '#EF7839'},
    {status: DeployStatus.UPDATING, color: '#EF7839'},
    {status: DeployStatus.TESTING, color: '#EF7839'},
    {status: DeployStatus.STARTING, color: '#EF7839'},
    {status: DeployStatus.STOPPING, color: '#EF7839'},
    {status: DeployStatus.OPERATION_INPROGRESS, color: '#EF7839'},
    {status: DeployStatus.FAILOVER_APPLYING, color: '#EF7839'},
    {status: DeployStatus.FAILBACK_APPLYING, color: '#EF7839'},
    {status: DeployStatus.PRE_FAILBACK_APPLYING, color: '#EF7839'},
    {status: DeployStatus.POST_FAILBACK_APPLYING, color: '#EF7839'},
    {status: DeployStatus.STARTING_AGENT, color: '#EF7839'},
    {status: DeployStatus.STOPPING_AGENT, color: '#EF7839'},
    {status: DeployStatus.DEPLOYED, color: '#188038'},
    {status: DeployStatus.TERMINATED, color: '#188038'},
    {status: DeployStatus.CONFIGURED, color: '#188038'},
    {status: DeployStatus.UPDATED, color: '#188038'},
    {status: DeployStatus.TESTED, color: '#188038'},
    {status: DeployStatus.STOPPED, color: '#188038'},
    {status: DeployStatus.SUCCESS, color: '#188038'},
    {status: DeployStatus.FAILED, color: '#B53B20'},
    {status: DeployStatus.TERMINATION_FAILED, color: '#B53B20'},
    {status: DeployStatus.CONFIGURATION_FAILED, color: '#B53B20'},
    {status: DeployStatus.UPDATE_FAILED, color: '#B53B20'},
    {status: DeployStatus.TEST_FAILED, color: '#B53B20'},
    {status: DeployStatus.FAILOVER_FAILED, color: '#B53B20'},
    {status: DeployStatus.FAILBACK_FAILED, color: '#B53B20'},
    {status: DeployStatus.PRE_FAILBACK_FAILED, color: '#B53B20'},
    {status: DeployStatus.POST_FAILBACK_FAILED, color: '#B53B20'},
    {status: DeployStatus.INITIALIZING, color: '#EF7839'},
    {status: DeployStatus.INITIALIZED, color: '#188038'},
    {status: DeployStatus.INITIALIZE_FAILED, color: '#B53B20'},
    {status: DeployStatus.START_FAILED, color: '#B53B20'},
    {status: DeployStatus.STOP_FAILED, color: '#B53B20'},
  ];

  selectedCobBlueprint: any;
  instanceByCobServiceDefinition: any;
  isCobInsSelectionLoaded = false;
  sch1: string;
  sch2: string;
  cobResults: any;
  timeZone: any;
  JumpboxTypes = JumpboxTypes;
  private destroy$ = new Subject<void>();
  years = [];
  months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  weeks = ['Week 1', 'Week 2', 'Week 3', 'Week 4', 'Week 5'];
  days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  selectedYr: string;
  selectedMonth: string;
  selectedWeek: string;
  Constants = Constants;
  viewDate: Date = new Date();
  events: CalendarEvent[] = [];
  schedules: any;
  recentActivityInstances: any;
  isAWS: boolean;
  azureCobEnabled: any;

  constructor(private authService: AuthService, private tenantService: TenantService, public datepipe: DatePipe,
    private toastrService: CustomToastrService, private router: Router, private instanceService: InstancesService,
    public sidenavService: SidenavService, private toastrErrorService: ToastrErrorService, private route: ActivatedRoute,
    private blueprintsService: BlueprintsService, private solutionsService: SolutionsService, public solutionVersionsService: SolutionVersionsService,
    private permissionsService: PermissionsService, private cobService: CobService,  private jumpboxService: JumpboxService, private schedulerService: SchedulerService, 
    public dialog: MatDialog, private titlecasePipe: TitleCasePipe, private disasterRecoveryService: DisasterRecoveryService, private featureService: FeatureService, private cdr: ChangeDetectorRef) {
    
  }

  ngOnInit(): void {
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.DASHBOARD';
    this.tenant = this.authService.principal.provider;
    this.tenantId = this.route.snapshot.params.id;
    this.tenantService.tenantData$.subscribe((data: any) => {
      this.isAWS = data === CloudProvider.AWS ? true : false;
    });
    this.tenantService.tenant$.pipe(filter(tenant => tenant != null),take(1),takeUntilDestroyed(this.destroyRef)).subscribe(tenant => {
    this.isExternalTenant = tenant?.origin === TenantOrigin.EXTERNAL? true : false;
    });
    this.getInstanceDetails();
    this.getBlueprints();
    this.getJumpbox();
    this.getSchedules();
    this.getFeatureByTenantId(this.tenantId);
  }


  getJumpbox(): void {
    this.jumpboxService.getJumpboxes(this.tenantId)
    .pipe(
      // Level 3: Request lifecycle management
      takeUntil(this.destroy$),

      // Level 4: Error handling
      catchError(error => {
        // Handle specific error types
        if (error?.status === 404) {
          this.toastrService.errorMessage('Resource not found');
        } else if (error?.status === 403) {
          this.toastrService.errorMessage('Access denied');
        } else {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        }
        return throwError(() => error);
      })
    )
    .subscribe({
      next: (response: any) => {
        // Handle successful response
        if (Array.isArray(response)) {
          // Show the toastr
          this.showJumpBox = this.checkExpiryAndShowJumpBox(response);
          // Update loading states
          this.isInsSelectionLoaded = true;
      }
      },
      error: () => {
        // Additional error handling
        this.isInsSelectionLoaded = true;
      }
    });
  }


  /**
 * Checks if any jumpbox entries are within 4 hours of expiration and have completed status
 * @param entries - Array of jumpbox entries to check
 * @returns boolean indicating if any entry meets the expiration criteria
 * @throws Error if invalid date or entry format
 */
  checkExpiryAndShowJumpBox(entries: Jumpbox[]): boolean {
    try {
      // Constants
      const FOUR_HOURS_MS = "4:00";
      const currentUTC = new Date();

      // Input validation
      if (!Array.isArray(entries)) {
        throw new Error('Invalid input: entries must be an array');
      }

      return entries.some((entry: Jumpbox): boolean => {
        try {
          // Validate entry
          if (!entry.expiresAt || typeof entry.expiresAt !== 'string') {
            throw new Error('Invalid entry: missing or invalid expiresAt');
          }

          // Parse dates
          const expiryDate: Date = new Date(entry.expiresAt);
          const expiryTimestamp: number = expiryDate.getTime();

          if (isNaN(expiryTimestamp)) {
            throw new Error('Invalid expiry date format');
          }


          // Check if dates are on the same day
          if (expiryDate.getDate() === currentUTC.getUTCDate() &&
            expiryDate.getMonth() === currentUTC.getUTCMonth() &&
            expiryDate.getFullYear() === currentUTC.getUTCFullYear()) {

            const getexpiryMins = expiryDate.getMinutes();
            const getexpiryHrs = expiryDate.getHours();
            const getExp = `${getexpiryHrs}:${getexpiryMins}`;


            const getcurrentUTCMins = currentUTC.getUTCMinutes();
            const getcurrentUTCHrs = currentUTC.getUTCHours();
            const finalUTC = `${getcurrentUTCHrs}:${getcurrentUTCMins}`;


            const timeDifference = this.getDifference(getExp, finalUTC);

            return FOUR_HOURS_MS >= timeDifference &&
              entry.status === JumpboxTypes.COMPLETED;
          }

          return false;
        } catch (entryError) {
          return false; // Skip invalid entries
        }
      });

    } catch (error) {
      throw error; // Re-throw to let caller handle the error
    }
  }

  getDifference(start?: string, end?: string): string {
    const diff = this.getTimeDifferenceInMinutes(start, end);
    const hours = Math.floor(Math.abs(diff) / 60);
    const minutes = Math.abs(diff) % 60;
    return `${hours}:${minutes}`;
  }

  getTimeDifferenceInMinutes(start?: string, end?: string): number {
    const [startHours, startMinutes] = start.split(":").map(Number);
    const [endHours, endMinutes] = end.split(":").map(Number);
    const startTotalMinutes = startHours * 60 + startMinutes;
    const endTotalMinutes = endHours * 60 + endMinutes;

    return endTotalMinutes - startTotalMinutes;
  }


  handleJumpboxNotification(value?: boolean): void {
    this.showJumpBox = value;
  }

  getBlueprints(): void {
    this.blueprintsService.getBlueprints()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(blueprints => {
        blueprints = blueprints?.sort((a, b) => new Date(a?.dateCreated)?.getTime() - new Date(b?.dateCreated)?.getTime() ? -1 : 1);
        this.blueprints = blueprints?.filter(item => item?.tenantId === this.tenantId);
        this.selectedBlueprint = this.blueprints[0];
        this.selectedCobBlueprint = this.blueprints[0];
        if (this.selectedBlueprint) {
          this.blueprintChanged(this.selectedBlueprint);
          this.selectedBlueprintForClass = this.blueprints[0];
          this.blueprintChangedForClass(this.selectedBlueprintForClass);
        } else {
          this.isInsSelectionLoaded = true;
          this.createInstanceByDatazoneTable();
          this.isInsClassLoaded = true;
          this.isInstanceLoaded = true;
          this.insightTiles.map(item => item.loading = false);
        }
        if (this.selectedCobBlueprint) {
          this.blueprintCobChanged(this.selectedCobBlueprint);
        }
      }, (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  blueprintChanged(value): void {
    if (!this.instancePermission) {
      return;
    }
    this.isInsSelectionLoaded = false;
    this.selectedBlueprint = value;
    const obj = {
      blueprintId: value?.id,
      tenantId: value?.tenantId,
      ...(this.instanceSize > 0 && { size: this.instanceSize })
    };
    this.instanceService.getInstances(obj)
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (instances: any) => {
        this.isInsSelectionLoaded = true;
        this.instances = instances?.data;
        this.instances.forEach(instance => {
          this.solutionsService.getSolutionVersion(instance?.solutionId, instance?.solutionVersionId)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(version => {
            instance.version = version?.version;
            instance.releaseVersion = version?.releaseVersion;
          },
          (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
          });
        })
        this.instanceByServiceDefinition = new MatTableDataSource(this.instances);
      }, (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  blueprintCobChanged(value): void {
    if (!this.instancePermission) {
      return;
    }
    this.isCobInsSelectionLoaded = false;
    this.selectedCobBlueprint = value;
    const obj = {
      blueprintId: value?.id,
      tenantId: value?.tenantId,
      ...(this.instanceSize > 0 && { size: this.instanceSize })
    };
    this.instanceService.getInstances(obj)
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (instances: any) => {
        this.isCobInsSelectionLoaded = true;
        this.instances = instances?.data;
        this.instances.forEach(instance => {
          if(instance?.cob && instance?.cob?.inputs) {
            const propertyKey = Object.keys(instance?.cob?.inputs);
            const title = propertyKey[0];
            if(instance?.cob?.inputs[title]) {
              const cobSchedule1 = instance?.cob?.inputs[title]?.Schedule1;
              const cobSchedule2 = instance?.cob?.inputs[title]?.Schedule2;
              this.sch1 = cobSchedule1 ? cronstrue.toString(cobSchedule1) : '-';
              this.sch2 = cobSchedule2 ? cronstrue.toString(cobSchedule2) : '-';
              this.timeZone = instance?.cob?.inputs[title]?.ScheduleTimeZone || '-';
            }
            this.cobService.getCobConfigResults(instance.id)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe((cobResults: any) => {
                  const size = cobResults?.total;
                  this.cobService.getCobConfigResults(instance.id, size)
                  .pipe(takeUntilDestroyed(this.destroyRef))
                  .subscribe((cobResults: any) => {
                    this.cobResults = cobResults.data;
                    if(this.cobResults?.length > 0) {
                      this.cobResults?.forEach(element => {
                        element.updatedStages = [];
                        let obj;
                        element.stages = element?.stages.filter(item => item.stage !== 'COB-REPORT');
                        element?.stages.forEach(innerElement => {
                          if(element?.updatedStages?.find(item => (item.stage === innerElement.stage) && (innerElement.status.toLowerCase() !== 'started'))) {
                            element.updatedStages.find(item => (item.stage === innerElement.stage)).status = innerElement.status.toLowerCase();
                          } else {
                          obj = innerElement;
                          element.updatedStages = [...element.updatedStages, obj];
                          }
                        })
                        element.updatedStages.find(item => (item.status.toLowerCase() === 'failed')) ? element.status = 'failed' : (element.updatedStages.find(item => (item.status.toLowerCase() === 'started'))) ? element.status = 'started' : ((element.updatedStages.find(item => (item.status.toLowerCase() === 'not started'))) ? element.status = 'not started' : element.status = 'completed');
                        let startedElement;
                        if(element?.status.toLowerCase() === 'started' && element?.updatedStages.find(item => (item.status.toLowerCase() === 'started'))) {
                          startedElement = element?.updatedStages.find(item => (item.status.toLowerCase() === 'started'));
                        if(startedElement) {
                          instance.dashboardCobstatus = startedElement.stage + ' In progress';
                          instance.spinner = 'progress';
                          }
                        } else if(!instance.dashboardCobstatus) {
                            instance.dashboardCobstatus =  'COB Scheduled';
                            instance.spinner = 'scheduled';
                        }
                      });
                    } else {
                      instance.dashboardCobstatus = 'COB Scheduled';
                      instance.spinner = 'scheduled';
                    }
                  });
              });
          } else {
            instance.dashboardCobstatus = 'COB Not Scheduled';
            instance.spinner = 'not_scheduled';
          }
        })
        this.instanceByCobServiceDefinition = new MatTableDataSource(this.instances);
      }, (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  blueprintChangedForClass(value): void {
    if (!this.instancePermission) {
      return;
    }
    this.isInsClassLoaded = false;
    this.selectedBlueprintForClass = value;
    const obj = {
      blueprintId: value?.id,
      tenantId: value?.tenantId,
      ...(this.instanceSize > 0 && { size: this.instanceSize })
    };
    this.instanceService.getInstances(obj)
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (instances: any) => {
        this.isInsClassLoaded = true;
        this.instancesForClass = instances?.data;
        this.createInstanceByDatazoneTable();
      }, (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  getInstanceDetails(): void {
    this.isInstanceLoaded = false;
    this.instanceByStatus = [];
    this.yearDropdown = [];
    this.chartData = [];
    const instanceObj = {
      tenantId: this.tenantId
    };
    this.instanceService.getInstances(instanceObj)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if(data) {
          this.instanceSize = data?.total;
          const instanceObj = {
            tenantId: this.tenantId,
            ...(this.instanceSize > 0 && { size: this.instanceSize })
          };
        this.instanceService.getInstances(instanceObj)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(instances => {
            if (instances) {
              this.isInstanceLoaded = true;
              this.insightTiles.find(item => item.key === 'total').count = instances.data?.length;
              this.insightTiles.find(item => item.key === 'total').loading = false;

              this.insightTiles.find(item => item.key === DeployStatus.DEPLOYED).count = instances.data
              .filter(instance => instance.status === DeployStatus.DEPLOYED).length;
            this.insightTiles.find(item => item.key === DeployStatus.DEPLOYED).loading = false;

              this.insightTiles.find(item => item.key === DeployStatus.DEPLOYING).count = instances.data
                .filter(instance => instance.status === DeployStatus.DEPLOYING).length;
              this.insightTiles.find(item => item.key === DeployStatus.DEPLOYING).loading = false;

              this.instanceDetails = instances.data;
              this.disasterRecoveryService.setDrStatus(instances.data, true);
              this.recentActivityInstances = instances.data?.filter(item => this.inprogressStatuses.includes(item.status));
              this.recentActivityInstances = this.recentActivityInstances.sort((a,b) => a.dateUpdated < b.dateUpdated ? 1 : a.dateUpdated > b.dateUpdated ? -1 : 0);

              this.instanceDetails.forEach(instance => {
                const statusTypeExist = this.instanceByStatus.find(item => item?.name === instance.status);
                if (statusTypeExist) {
                  statusTypeExist.value = statusTypeExist.value + 1;
                } else {
                  const obj = {
                    name: '',
                    value: 0,
                  };
                  if(instance.status) {
                    obj.name = instance.status;
                    obj.value = obj.value + 1;
                    this.instanceByStatus = [...this.instanceByStatus, obj];
                  }
                }
              })
              this.createInstanceBySolutionPiechart();
            }
          });
        }
      },
      (error) => {
        if (error.error?.code === '11045' || error.error?.message?.includes('does not have read permission')) {
          this.instancePermission = false;
        }
        this.isInstanceLoaded = true;
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  createInstanceByDatazoneTable(): void {
    this.instanceByClass = [
      {
        key: 'A',
        name: 'Class A',
        value: 0
      },
      {
        key: 'B',
        name: 'Class B',
        value: 0
      },
      {
        key: 'C',
        name: 'Class C',
        value: 0
      },
      {
        key: 'D',
        name: 'Class D',
        value: 0
      },
      {
        key: 'E',
        name: 'Class E',
        value: 0
      }
    ];
    this.instancesForClass?.forEach(instance => {
      if (instance.deploymentClass === 'A') {
        const obj = this.instanceByClass.find(item => item.key === 'A');
        obj.value = obj.value + 1;
      } else if (instance.deploymentClass === 'B') {
        const obj = this.instanceByClass.find(item => item.key === 'B');
        obj.value = obj.value + 1;
      } else if (instance.deploymentClass === 'C') {
        const obj = this.instanceByClass.find(item => item.key === 'C');
        obj.value = obj.value + 1;
      } else if (instance.deploymentClass === 'D') {
        const obj = this.instanceByClass.find(item => item.key === 'D');
        obj.value = obj.value + 1;
      } else if (instance.deploymentClass === 'E') {
        const obj = this.instanceByClass.find(item => item.key === 'E');
        obj.value = obj.value + 1;
      }

      const dateCreated = this.datepipe.transform(instance.dateCreated, 'MMM,y')?.split(',');
      if (dateCreated) {
        if (!(this.yearDropdown.find(item => item === dateCreated[1]))) {
          this.yearDropdown = [...this.yearDropdown, dateCreated[1]];
        }
        const dateExist = this.chartData.find(data => data.month === dateCreated[0] && data.year === dateCreated[1]);
        if (dateExist) {
          this.chartData.find(data => data.month === dateCreated[0] && data.year === dateCreated[1]).value = dateExist.value + 1;
        } else {
          const chartDataObj: any = {};
          chartDataObj.month = dateCreated[0];
          chartDataObj.year = dateCreated[1];
          chartDataObj.value = 1;
          if (instance.status === 'deployed') {
            chartDataObj.deployed = 1;
          } else if (instance.status === 'deploying') {
            chartDataObj.deploying = 1;
          }
          else {
            chartDataObj.deploying = 0;
          }
          this.chartData = [...this.chartData, chartDataObj];
        }
      }
    });
    this.selectedYear = this.yearDropdown[0];
  }

  createInstanceBySolutionPiechart(): void {
    const colorCodes = [];
    this.instanceByStatus.forEach(item => {
      const matchStatus = this.colorsByStatus.find(element=> element.status.toLocaleLowerCase() === item?.name?.toLocaleLowerCase());
      if (matchStatus) {
        colorCodes.push(matchStatus.color);
      }
      item.name = item?.name?.charAt(0).toUpperCase() + item.name.slice(1) + ' (' + item.value + ')';
    });
    this.instanceBySolutionPiechart = {
      title: {
        text: this.instanceDetails?.length,
        subtext: 'No of Environments',
        subtextStyle: {
          color: '#293276',
          fontFamily: 'worksans',
        },
        top: 'center',
        right: 'center',
        textStyle: {
          color: '#293276',
          fontFamily: 'worksans',
          fontSize: 50,
          fontWeight: 600,
        }
      },
      tooltip: {
        trigger: 'item',
        formatter: '{b}',
      },
      legend: {
        selectedMode: false,
        show: true,
        top: 'center',
        right: '0%',
        orient: 'vertical',
        type: 'plain',
        itemGap: 10,
        itemWidth: 14,
        itemHeight: 14,
        textStyle: {
          color: '#293276',
          fontFamily: 'worksans',
          fontSize: 12
        }
      },
      series: [
        {
          type: 'pie',
          radius: ['80%', '100%'],
          avoidLabelOverlap: false,
          top: 20,
          bottom: 10,
          label: {
            show: false,
            position: 'bottom',
            formatter: '',
            fontSize: '20'
          },
          labelLine: {
            show: false
          },
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 0
          },
          color: colorCodes,
          data: this.instanceByStatus,
        }
      ]
    };
  }

  labelClick(): void {
    setTimeout(() => {
      if (document.getElementsByClassName("blueprint-dropdown")) {
        const element = <HTMLElement> document.getElementsByClassName("blueprint-dropdown")[0];
        if (element) {
          element.classList.add("margin-style");
        }
      }
    }, 100);
  }

  openInstanceDetails(instance): void {
    this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.SERVICE_DEFINITION';
    this.router.navigate(['/',this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.BLUEPRINTS, instance.blueprintId, RouterSegments.ENVIRONMENT, instance.id]);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  handleEvent(event: CalendarEvent): void {
    this.dialog.open(ScheduleDetailsComponent, {
      disableClose: false,
      panelClass: 'default-dialog-wrapper',
      width: '436px',
      minHeight: '250px',
      autoFocus: false,
      data: {
        event
      }
    })
  }

  getSchedules(): void {
    this.schedulerService.getSchedules(this.tenantId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        if (response.total > 10) {
          const size = response.total
          this.schedulerService.getSchedules(this.tenantId, size)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(results => {
              this.schedules = results.data;
              this.schedules.forEach(item => {
                if (item.startTime?.split('')?.pop() === 'Z') {
                  item.startTime = item?.startTime?.slice(0, -1);
                }
                if (item.endTime?.split('')?.pop() === 'Z') {
                  item.endTime = item?.endTime?.slice(0, -1);
                }
                item.action = item.name?.includes('start') ? 'Start Environment' : item.name?.includes('stop') ? 'Stop Environment' : (item.name?.includes('config') || item.name?.includes('apply')) ? 'Apply Configuration' : '';
                if (item.startTime && !this.years.find(element => (Number(element) === new Date(item.startTime).getFullYear()))) {
                  this.years = [...this.years, new Date(item.startTime).getFullYear().toString()]
                }
                if (item.endTime && !this.years.find(element => (Number(element) === new Date(item.endTime).getFullYear()))) {
                  this.years = [...this.years, new Date(item.endTime).getFullYear().toString()]
                }
              })
              this.years = this.years.sort((a,b) => b.localeCompare(a));
              this.plotEvents(this.viewDate);
              this.showSchedule = this.checkNextRunSchedule(this.schedules);
            })
        } else {
          this.schedules = response.data;
          this.schedules.forEach(item => {
            item.action = item.name?.includes('start') ? 'Start Environment' : item.name?.includes('stop') ? 'Stop Environment' : (item.name?.includes('config') || item.name?.includes('apply')) ? 'Apply Configuration' : '';
            if (item.startTime && !this.years.find(element => (Number(element) === new Date(item.startTime).getFullYear()))) {
              this.years = [...this.years, new Date(item.startTime).getFullYear().toString()]
            }
            if (item.endTime && !this.years.find(element => (Number(element) === new Date(item.endTime).getFullYear()))) {
              this.years = [...this.years, new Date(item.endTime).getFullYear().toString()]
            }
          })
          this.years = this.years.sort((a,b) => b.localeCompare(a));
          this.plotEvents(this.viewDate);
          this.showSchedule = this.checkNextRunSchedule(this.schedules);
        }
      }, (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  selectionChanged(dropdown, value: any): void {
    if (dropdown === 'year') {
      this.selectedYr = value;
    } else if (dropdown === 'month') {
      this.selectedMonth = value;
    } else if (dropdown === 'week') {
      this.selectedWeek = value;
    }
    if (this.selectedYr && this.selectedMonth && this.selectedWeek) {
      let startDate = new Date();
      startDate.setHours(0,0,0,0);
      const month = this.months.findIndex(item => item === this.selectedMonth);
      startDate.setMonth(month);
      startDate.setFullYear(Number(this.selectedYr));
      startDate.setDate(1);
      if (startDate.getDate() === 1) {
        startDate.setDate(this.selectedWeek === 'Week 5' ? startDate.getDate() + 28 : this.selectedWeek === 'Week 2' ? startDate.getDate() + 7 : this.selectedWeek === 'Week 3' ? startDate.getDate() + 14
        : this.selectedWeek === 'Week 4' ? startDate.getDate() + 21 : startDate.getDate());
      } else {
        startDate.setDate(this.selectedWeek === 'Week 1' ? startDate.getDate() - 7 : this.selectedWeek === 'Week 3' ? startDate.getDate() + 7 : this.selectedWeek === 'Week 4' ? startDate.getDate() + 14
        : this.selectedWeek === 'Week 5' ? startDate.getDate() + 21 : startDate.getDate());
      }
      this.plotEvents(startDate);
    }
  }

  plotEvents(startDate): void {
    this.events = [];
    this.viewDate = startDate;
    const endDate = cloneDeep(startDate);
    endDate.setDate(startDate.getDate() + 7);
    const color = {
      primary: '#293276',
      secondary: '#EAF2FF'
    };

    this.schedules.forEach(exp => {
      let events = [];
      const first = cloneDeep(startDate);
      [1,2,3,4,5,6,7].forEach(item => {
        if (exp.frequency === 'one_time') {
          if (this.datepipe.transform(exp.startTime, "yyyy-MM-dd") === this.datepipe.transform(first, "yyyy-MM-dd")) {
            const obj: any = {};
            obj.date = this.datepipe.transform(exp.startTime, "yyyy-MM-dd");
            obj.time = this.datepipe.transform(exp.startTime, "HH:mm");
            const start = new Date(obj.date).setHours(obj.time.split(':')[0], obj.time.split(':')[1], 0);
            const plotStart = cloneDeep(new Date(obj.date)).setHours(obj.time.split(':')[0], 0, 0);
            obj.title = this.titlecasePipe.transform(exp.action) + ' | ' + this.datepipe.transform(start, "dd MMM yyyy") + ' | ' + this.days[new Date(start).getDay()] + ' | ' + obj.time + ' UTC';
            obj.start = new Date(plotStart);
            obj.color = color;
            obj.metadata = exp.metadata;
            obj.element = exp;
            events = [...events, obj];
          }
        } else if (exp.cronExpression?.split(' ').reverse()[2].includes('/')) {
          const obj: any = {};
          obj.date = cloneDeep(first);
          obj.time = exp.cronExpression.split(' ')[2] + ' ' + exp.cronExpression.split(' ')[1];
          const start = obj.date.setHours(obj.time.split(' ')[0], obj.time.split(' ')[1], 0);
          const plotStart = cloneDeep(obj.date).setHours(obj.time.split(' ')[0], 0, 0);
          obj.title = this.titlecasePipe.transform(exp.action) + ' | ' + this.datepipe.transform(start, "dd MMM yyyy") + ' | ' + this.days[new Date(start).getDay()] + ' | ' + this.datepipe.transform(start, "HH:mm") + ' UTC';
          obj.start = new Date(plotStart);
          obj.color = color;
          obj.metadata = exp.metadata;
          obj.element = exp;
          obj.cronDefinition = cronstrue.toString(exp.cronExpression);
          const date = cloneDeep(obj.date).setHours(this.datepipe.transform(exp.startTime, "HH:mm").split(':')[0], this.datepipe.transform(exp.startTime, "HH:mm").split(':')[1]);
          const daysDiff = Number(this.datepipe.transform(date, "dd")) - 1;
          const occurance = (daysDiff % Number(exp.cronExpression.split(' ').reverse()[2].split('/')[1])) === 0 && (this.getUTCTimestamp(exp.startTime, 'time') <= this.getUTCTimestamp(obj.date, 'time')) && (this.getUTCTimestamp(obj.date, 'time') <= this.getUTCTimestamp(exp.endTime, 'time'));
          if (occurance) {
            events = [...events, obj];
          }
        } else {
          if (this.getUTCTimestamp(exp.endTime, 'time') > this.getUTCTimestamp(first, 'time')) {
            const element: any = {};
            const options = {
              currentDate: new Date(cloneDeep(first).setHours(0, 0, 0)),
              endDate: new Date(exp.endTime),
            };
            try {
              const interval = CronExpressionParser.parse(exp.cronExpression, options);
              const date: any = interval.next();
              const next = moment(new Date(date)).utc().toDate();
              if (!events.find(item => item.date.getDate() === next.getDate() && item.date.getMonth() === next.getMonth() && this.getUTCTimestamp(item.date.getTime(), 'time') === this.getUTCTimestamp(next.getTime(), 'time')) &&
                (this.getUTCTimestamp(exp.startTime, 'time') <= this.getUTCTimestamp(next, 'time')) && (this.getUTCTimestamp(next, 'time') <= this.getUTCTimestamp(exp.endTime, 'time'))) {
                element.date = cloneDeep(next);
                element.time = exp.cronExpression.split(' ')[2] + ' ' + exp.cronExpression.split(' ')[1];
                const start = element.date.setHours(element.time.split(' ')[0], element.time.split(' ')[1], 0);
                const plotStart = cloneDeep(element.date).setHours(element.time.split(' ')[0], 0, 0);
                element.start = new Date(plotStart);
                element.title = this.titlecasePipe.transform(exp.action) + ' | ' + this.datepipe.transform(start, "dd MMM yyyy") + ' | ' + this.days[new Date(start).getDay()] + ' | ' + this.datepipe.transform(start, "HH:mm") + ' UTC';
                element.color = color;
                element.metadata = exp.metadata;
                element.element = exp;
                element.cronDefinition = cronstrue.toString(exp.cronExpression);
                events = [...events, element];
              }
            } catch (err) {}
          }
        }
        first.setDate(first.getDate() + 1);
      });
      this.events = [...this.events, ...events];
    })
  }

  getUTCTimestamp(date, format): any {
    if (format === 'date') {
      return Date.parse(moment(new Date(date)).utc().format('DD MMM YYYY'));
    } else if (format === 'time') {
      return Date.parse(moment(new Date(date)).utc().format('DD MMM YYYY HH:mm:ss'));
    }
  }

  instanceNameClick(instance): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId,
      RouterSegments.BLUEPRINTS, instance.blueprintId, RouterSegments.ENVIRONMENT, instance.id]);
  }

  handleScheduleNotification(value?: boolean): void {
    this.showSchedule = value;
  }
  /**
   * 
   * @param data schedule response
   * @returns boolean if Jobs scheduled to run in next 2 hours
   */
  checkNextRunSchedule(data:any):boolean{
    const today = new Date();  // current time
    const todaytime = today.getTime();
    const twoHoursLater = todaytime + 2 * 60 * 60 * 1000; // now + 2 hours
    const filtered = data.filter(item => {
      const execTime = new Date(this.normalizeUtc(item.startTime)).getTime();// parses ISO date correctly
      return execTime >= todaytime && execTime <= twoHoursLater && item.status === "active";
    });
    if(filtered.length > 0){
      return true;
    }else{
      return false;
    }
  }
  normalizeUtc(dateStr) {
    return dateStr?.endsWith('Z') ? dateStr : dateStr + 'Z';
  }

  getFeatureByTenantId(tenantId: string) {
    this.featureService.getTenantIdFeatureFlags(tenantId).subscribe({
      next: (featureFlags: FeatureFlagsResponse) => {
        this.azureCobEnabled = featureFlags.featureFlags.some(flag => flag.id === FeatureFlags.AZURE_COB && (flag.enabled === true || flag.enabled === 'true'));
        this.cdr.detectChanges();
      },
      error: () => {
        this.cdr.detectChanges();
      }
    });
  }
}
